import React, { useContext } from 'react';
import { FirebaseContext } from '.';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { ReadlistData } from './types';
import { Link } from 'react-router-dom';
import Loading from './Loading';

const dedupe = <T extends { id: string } >(list1: T[], list2: T[] = []): T[] => {
  const temp: Map<string, T> = new Map();
  list1.forEach(item => temp.set(item.id, item));
  list2.forEach(item => temp.set(item.id, item));
  return [...temp.values()];
};

interface ReadlistElementProps {
  readlist: ReadlistData,
};

const ReadlistElement = ({ readlist }: ReadlistElementProps) => {
  const { auth } = useContext(FirebaseContext);

  return (
    <Link to={ '/readlist/' + readlist.id } ><span>{ readlist.name }</span> { auth.currentUser?.uid === readlist.owner && <span className='badge bg-secondary'>Owner</span> }</Link>
  );
};

const Readlists = () => {
  const { auth, firestore, analytics } = useContext(FirebaseContext);
  const readlistsCollection = firestore.collection('readlists');
  const ownedQuery = readlistsCollection.where('owner', '==', auth.currentUser?.uid);
  const collaboratorQuery = readlistsCollection.where('collaborators', 'array-contains', auth.currentUser?.uid);
  const [ ownedReadlists, ownedLoading, ownedError ] = useCollectionData<ReadlistData>(ownedQuery, { idField: 'id' });
  const [ collaboratorReadlists, collaboratorLoading, collaboratorError ] = useCollectionData<ReadlistData>(collaboratorQuery, { idField: 'id' });

  const loading = ownedLoading || collaboratorLoading;
  const readlists = dedupe(ownedReadlists || [], collaboratorReadlists || []);
  
  if (ownedError) {
    console.log(ownedError);
    analytics.logEvent('exception', { description: 'Fetching owned readlists failed', fatal: false, ownedError });
  }

  if (collaboratorError) {
    console.log(collaboratorError);
    analytics.logEvent('exception', { description: 'Fetching collaborator readlists failed', fatal: false, collaboratorError });
  }

  return (
    <div className='col'>
      <Loading loading={ loading } />
      { (!!!readlists || readlists.length === 0) && !!!loading && <div className='alert alert-warning'>Seems that you have not created any readlist so far.</div> }
      <ul className='m-0 p-0 list-group'>
        { readlists && readlists.map(readlist => <li className='list-group-item' key={ readlist.id }><ReadlistElement readlist={ readlist } /></li>)}
      </ul>
    </div>
  );
};

export default Readlists;